"use client";

import NProgress from "nprogress";
import { useEffect } from "react";
import "~/styles/vendor/nprogress.css";

NProgress.configure({ showSpinner: false, trickleSpeed: 100 });

export function NProgressComponent() {
	useEffect(() => {
		document.addEventListener("click", handleClick);

		return () => {
			document.removeEventListener("click", handleClick);
		};
	}, []);

	return null;
}

function handleClick(event: MouseEvent) {
	const link =
		event.target instanceof HTMLElement || event.target instanceof SVGElement
			? event.target.closest("a")
			: null;

	if (link) {
		const hasKey = event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;
		const haxCustomTarget = link.hasAttribute("target") && link.getAttribute("target") !== "_self";
		const isButton = link.hasAttribute("role") && link.getAttribute("role") === "button";
		const isDownload = link.hasAttribute("download");
		const isHash = link.href.startsWith("#");
		const isMailto = link.href.startsWith("mailto:");
		const isTel = link.href.startsWith("tel:");
		const isJavascript = link.href.startsWith("javascript:");
		const isExternal = link.origin && link.origin !== window.location.origin;
		const isSamePath = link.pathname && link.pathname === window.location.pathname;
		const isSameSearch = link.search && link.search === window.location.search;

		if (
			!(
				hasKey ||
				haxCustomTarget ||
				isButton ||
				isDownload ||
				isHash ||
				isMailto ||
				isTel ||
				isJavascript ||
				isExternal ||
				isSamePath ||
				isSameSearch
			)
		) {
			NProgress.start();
		}
	}

	const npgclass = document.querySelectorAll("html");

	((history) => {
		const pushState = history.pushState;

		history.pushState = (...args) => {
			NProgress.done();

			[].forEach.call(npgclass, (el: Element) => {
				el.classList.remove("nprogress-busy");
			});

			return pushState.apply(history, args);
		};
	})(window.history);
}
